/*
* Filters on template page "collection family"
*/
document.addEventListener('DOMContentLoaded', function () {
  const $filtersButton = document.querySelector('.collection-family__filters');
  const $filters = document.querySelector('.filters-collections');
  const $closeIcon = document.querySelector('.filters-collections__close .close-icon');
  const $stickyFiltersTrigger = document.querySelector('.collection-family__page-content');
  const $stickyFilters = document.querySelector('.sticky-filters');

  if (!$filtersButton || !$filters || !$closeIcon) return;

  $filtersButton.addEventListener('click', function () {
    $filters.classList.add('active');
  });

  $closeIcon.addEventListener('click', function () {
    $filters.classList.remove('active');
  });

  document.querySelectorAll('.filters-collections__item').forEach(function (link) {
    link.addEventListener('click', function () {
      $filters.classList.remove('active');
    });
  });

  if ($stickyFiltersTrigger && $stickyFilters) {
    const triggerPositionY = $stickyFiltersTrigger.getBoundingClientRect().top + window.scrollY;
    window.addEventListener('scroll', function () {
      $stickyFilters.classList.toggle('active', window.scrollY > triggerPositionY);
    }, { passive: true });
  }
});
